/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-04-26 18:01:48
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-04-26 18:03:44
 * @FilePath: /unifyxp-v2-store-portal/src/components/GreenAddBtn/GreenAddBtn.tsx
 */
import { getI18nFromGeneral } from '@/src/tools/tools';
import css from './css.less';
import React from 'react';
const Add = (props) => {
  const { addFun, addText, className = '', disable } = props;

  const click = () => {
    if (disable) {
    } else {
      if (addFun) addFun();
    }
  };
  return (
    <div
      className={`${css.addNew} ${disable ? css.disable : css.enable} ${
        className || ''
      }`}
      onClick={click}>
      {addText || getI18nFromGeneral('general.greenAddBtn.add_collapse')}
    </div>
  );
};
export default Add;
